export default __webpack_public_path__ + "static/spirits-of-the-forest-screenshot-902e4b190a0d753d4d0963d240a5cfe0.png";